import { render, staticRenderFns } from "./ProductCreateTranslation.vue?vue&type=template&id=72b4c763&"
import script from "./ProductCreateTranslation.vue?vue&type=script&lang=js&"
export * from "./ProductCreateTranslation.vue?vue&type=script&lang=js&"
import style0 from "./ProductCreateTranslation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports